import { render, staticRenderFns } from "./upload_file_page.vue?vue&type=template&id=37b39117&scoped=true"
import script from "./upload_file_page.vue?vue&type=script&lang=js"
export * from "./upload_file_page.vue?vue&type=script&lang=js"
import style0 from "./upload_file_page.vue?vue&type=style&index=0&id=37b39117&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b39117",
  null
  
)

export default component.exports